import time from 'utils/time';

const currentDate = time().formatCalendarDate();
export default currentDate;
